<template>
  <div>
    <v-card class="rounded-card">
      <v-card-text class="text--primary">
        <v-row dense align="center">
          <v-col cols="12" sm="9" class="text-truncate">
            <px-situacao-requisicao-icon :situacao="requisicao.situacao"/>
            {{ requisicao.identificador }}
            <px-requisicao-urgencia :urgencia="requisicao.urgencia"/>
          </v-col>
          <v-col v-if="isAberta && hasRoleCompradorOuRequisicao"
                 cols="12"
                 sm="3"
                 class="text-right">
            <v-btn v-if="hasRoleComprador"
                   class="elevation-0 normal-btn-text rounded-tag-small" color="primary"
                   @click="criarCotacao">
              Criar cotação
            </v-btn>
            <px-requisicao-options
              :requisicao="requisicao"
              :has-role-comprador="hasRoleComprador"
              :has-role-requisicao="hasRoleRequisicao"
              :bloquear-edicao-ou-copia="bloquearEdicaoOuCopia"
              @update="onUpdate"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" class="caption">
            <v-icon>mdi-domain</v-icon>
            {{ requisicao.comprador.pessoa.nome }} ({{ requisicao.comprador.pessoa.cnpj | cnpj }})
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" class="caption">
            <v-icon>mdi-map-marker</v-icon>
            {{ requisicao.comprador.endereco | endereco }}
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" class="caption">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon>mdi-calendar</v-icon>
                  {{ requisicao.createdIn | date(true) }}
                </span>
              </template>
              <span>Data de criação da Requisição</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Código</span>
            <div>
              {{ requisicao.id }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Projeto</span>
            <div>
              {{ projeto | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Centro de custo</span>
            <div>
              {{ centroCusto | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Data de entrega solicitada</span>
            <div>
              {{ requisicao.dataEntrega | date | naoInformado }}
            </div>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Solicitante</span>
            <div>
              {{
                (requisicao.usuario ?
                  requisicao.usuario.nome : requisicao.nomeResponsavel) | naoInformado
              }}
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observações internas</span>
            <div>
              <px-show-large-text :large-text="requisicao.observacaoInterna"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Observações externas</span>
            <div>
              <px-show-large-text :large-text="requisicao.observacaoExterna"/>
            </div>
          </v-col>
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Finalidade da Compra</span>
            <div v-if="requisicao.finalidadeCompra">
              <px-finalidade-compra-value :finalidade-compra="requisicao.finalidadeCompra"/>
            </div>
            <div v-else>
              Não Informado
            </div>
          </v-col>
        </v-row>
        <v-row dense v-if="requisicao.codigoInterno">
          <v-col cols="12" sm="3">
            <span class="caption font-weight-bold">Código interno</span>
            <div>
              {{ requisicao.codigoInterno }}
            </div>
          </v-col>
        </v-row>
        <v-row dense v-if="requisicao.arquivos && requisicao.arquivos.length">
          <v-col cols="12">
            <span class="caption font-weight-bold">Anexos</span>
            <px-anexo-chip :files="requisicao.arquivos"
                           download-base-path="files/download-comprador"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="3">
            <px-responsaveis
              is-comprador
              :custom-path="customPath"
              :id="requisicao.id"
              :id-company="requisicao.comprador.id"
              :responsaveis="responsaveis"
              :roles="['ROLE_COMPRADOR']"
              :loading-responsaveis="loadingResponsaveis"
              :show-actions="hasRoleCompradorOuGestorCompras"
              modal-title="Alterar compradores responsáveis"
              listagem-title="Compradores responsáveis"
              label-autocomplete-responsavel="Comprador responsável"
              empty-responsaveis-text="Ainda não há nenhum comprador responsável"
              success-message-on-add="Comprador responsável adicionado!"
              success-message-on-remove="Comprador responsável removido!"
              @update-responsaveis="onUpdateResponsaveis"/>
          </v-col>
          <v-col cols="12" sm="9" v-if="isCancelado">
            <span class="caption font-weight-bold">Motivo do cancelamento</span>
            <div>
              <px-show-large-text v-if="requisicao.motivoRecusa"
                :large-text="requisicao.motivoRecusa"/>
              <span v-else>Acesse o detalhe do item para saber o motivo do cancelamento.</span>
            </div>
          </v-col>
        </v-row>
        <px-requisicao-detalhes-comprador class="mt-3" :requisicao="requisicao"/>
        <px-requisicao-detalhes-produtos class="mt-3" :requisicao="requisicao"
                                         @update="onUpdate" />
        <px-requisicao-detalhes-fornecedores v-if="showFornecedores"
                                             class="mt-3" :requisicao="requisicao"/>
        <px-requisicao-detalhes-links :requisicao="requisicao" class="mt-3" />
        <px-requisicao-detalhes-mensagens-personalizadas
          v-if="checkMessages"
          class="mt-3"
          :requisicao="requisicao"/>
        <px-requisicao-detalhes-logs :id-requisicao="requisicao.id" v-if="hasIntegracaoAtiva"/>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import RequisicaoOptions from '@/modules/requisicao/RequisicaoOptions.vue';
import { descWithCodigoInterno } from '@/utils/object-utils';
import { CUSTOM_PATH_RESPONSAVEL_REQUISICAO } from '@/utils/responsaveis-utils';
import ResponsaveisService from '@/api/responsaveis-service';
import { SituacaoRequisicao, ErpCamposIntegracao } from 'px-business-components';
import { mapGetters } from 'vuex';
import RequisicaoDetalhesComprador from './RequisicaoDetalhesComprador.vue';
import RequisicaoDetalhesProdutos from './RequisicaoDetalhesProdutos.vue';
import RequisicaoDetalhesFornecedores from './RequisicaoDetalhesFornecedores.vue';
import RequisicaoDetalhesMensagensPersonalizadas from './RequisicaoDetalhesMensagensPersonalizadas.vue';
import RequisicaoDetalhesLinks from './RequisicaoDetalhesLinks.vue';
import RequisicaoDetalhesLogs from './logs-requisicao/RequisicaoDetalhesLogs.vue';

export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      responsaveis: [],
      loadingResponsaveis: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador', 'hasRoleGestorCompras', 'hasRoleRequisicao']),
    ...mapGetters('entidade', ['hasIntegracaoAtiva', 'erpCamposIntegracao']),
    centroCusto() {
      return this.requisicao.centroCusto
        ? descWithCodigoInterno(this.requisicao.centroCusto) : null;
    },
    projeto() {
      return this.requisicao.projeto
        ? descWithCodigoInterno(this.requisicao.projeto) : null;
    },
    showFornecedores() {
      return this.requisicao.fornecedores && this.requisicao.fornecedores.length;
    },
    isAberta() {
      const sistuacoesAbertas = [
        SituacaoRequisicao.keys.RECEBIDA.key,
        SituacaoRequisicao.keys.EM_COTACAO.key,
        SituacaoRequisicao.keys.EM_COMPRA.key,
      ];
      return sistuacoesAbertas.includes(this.requisicao.situacao);
    },
    checkMessages() {
      return this.requisicao.mensagensPersonalizadas
        && this.requisicao.mensagensPersonalizadas.length;
    },
    hasRoleCompradorOuRequisicao() {
      return this.hasRoleComprador || this.hasRoleRequisicao;
    },
    hasRoleCompradorOuGestorCompras() {
      return this.hasRoleComprador || this.hasRoleGestorCompras;
    },
    customPath() {
      return CUSTOM_PATH_RESPONSAVEL_REQUISICAO;
    },
    bloquearEdicaoOuCopia() {
      return this.erpCamposIntegracao === ErpCamposIntegracao.keys.SENIOR_MEGA.key;
    },
    isCancelado() {
      return this.requisicao.situacao === SituacaoRequisicao.keys.CANCELADA.key;
    },
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    onUpdateResponsaveis() {
      this.getResponsaveisRequisicao();
    },
    getResponsaveisRequisicao() {
      this.loadingResponsaveis = true;
      ResponsaveisService.get(CUSTOM_PATH_RESPONSAVEL_REQUISICAO, this.requisicao.id)
        .then((response) => {
          this.responsaveis = response.data;
        })
        .finally(() => {
          this.loadingResponsaveis = false;
        });
    },
    criarCotacao() {
      this.$router.push({
        name: 'main.cotacoes.requisicao-cotacao',
        query: {
          idRequisicao: this.requisicao.id,
        },
        params: {
          isRascunho: false,
        },
      });
    },
  },
  created() {
    this.getResponsaveisRequisicao();
  },
  components: {
    pxRequisicaoDetalhesProdutos: RequisicaoDetalhesProdutos,
    pxRequisicaoDetalhesFornecedores: RequisicaoDetalhesFornecedores,
    pxRequisicaoOptions: RequisicaoOptions,
    pxRequisicaoDetalhesMensagensPersonalizadas: RequisicaoDetalhesMensagensPersonalizadas,
    pxRequisicaoDetalhesComprador: RequisicaoDetalhesComprador,
    pxRequisicaoDetalhesLinks: RequisicaoDetalhesLinks,
    pxRequisicaoDetalhesLogs: RequisicaoDetalhesLogs,
  },
};
</script>
